import { Divider, Label } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import { APP_LANDING_URL, BUSINESS_ACCOUNTS_GUIDE_URL, BUSINESS_ACCOUNTS_HOMEPAGE, HELP_CENTER_URL, HOW_IT_WORKS_URL, INFOBOARD_URL } from 'constants/routes';
import OtherLink from '../OtherLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Discover = _ref => {
  let {
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = useTranslate('header.main_navigation.about.discover');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Divider, {}),
      children: [/*#__PURE__*/_jsx(OtherLink, {
        url: HOW_IT_WORKS_URL,
        title: translate('items.how_it_works')
      }), /*#__PURE__*/_jsx(OtherLink, {
        url: APP_LANDING_URL,
        title: translate('items.app')
      }), /*#__PURE__*/_jsx(OtherLink, {
        url: HELP_CENTER_URL,
        title: translate('items.help')
      }), /*#__PURE__*/_jsx(OtherLink, {
        url: INFOBOARD_URL,
        title: translate('items.infoboard')
      }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsx(OtherLink, {
        url: BUSINESS_ACCOUNTS_HOMEPAGE,
        title: translate('items.pro')
      }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsx(OtherLink, {
        url: BUSINESS_ACCOUNTS_GUIDE_URL,
        title: translate('items.pro_guide')
      })]
    })]
  });
};

export default Discover;